import React from 'react';
import { ModalWrap } from '../../../../components/modal-wrap';
import { ButtonProps } from 'antd';
import warnImage from '../../../../assets/images/warn-yellow.png';
import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly onOk: () => Promise<boolean>;
  readonly onClose?: () => void;
  readonly title: string;
  readonly context: React.ReactNode;
  readonly okText?: string;
  readonly notCancel?: number; // 1不要取消按钮
  readonly className?: string;
  readonly okButtonProps?: ButtonProps;
}
export const CommonOperateModal = (props: IProps) => {
  const {
    onOk,
    onClose,
    title,
    context,
    okText,
    notCancel,
    className,
    okButtonProps = {},
  } = props;
  return (
    <ModalWrap
      width="480px"
      onOk={onOk}
      onClose={onClose}
      oKText={okText}
      okButtonProps={okButtonProps}
      cancelText={notCancel === 1 ? '' : getFormatMessage('cancel')}
      title={
        <>
          <img
            src={warnImage}
            alt="Warning"
            style={{ marginRight: '10px', marginTop: '-2px' }}
          />
          <span>{title}</span>
        </>
      }
      className={className}
    >
      {context}
    </ModalWrap>
  );
};
